"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../baseSchema");
const baseViewSchema_1 = require("../baseSchema/baseViewSchema");
class ViewCreateDrippingSchema extends baseViewSchema_1.BaseViewSchema {
    constructor({ arrivedFrom, concept }) {
        super({ arrivedFrom });
        this.action = baseSchema_1.ActionsName.VIEW_CREATE_DRIPPING;
        this.concept = concept;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            action: this.action,
            concept: this.concept
        };
    }
}
exports.default = ViewCreateDrippingSchema;
